<template>
    <auction-imgs-overlay :imgs="imgs">
        <template #activator="{ attrs, on, setIndex }">
            <v-img :src="imgs[0]?.url" :aspect-ratio="1 / 1" width="140" contain class="grey-ef" v-bind="attrs" v-on="on" @click="setIndex(imgs[0])" style="cursor:pointer" />
        </template>
    </auction-imgs-overlay>
</template>

<script>
// import AuctionImgsOverlay from "../auction/auction-imgs-overlay.vue";
export default {
    // components: { AuctionImgsOverlay },
    props: ["imgs"],
};
</script>

<style></style>
